import "./_productTeaser";
import "./_productSwitcher";

$(document).ready(function () {});
